module.exports = __webpack_public_path__ + "img/logo.f93538fc.png";